import moment from 'moment-timezone';

import classNames from './styles.module.scss';

export const PipelineArrow = () => (
  <div className={classNames.pipelineArrow}>
    <svg width="20" height="20" fill="none" viewBox="0 0 20 20" aria-hidden="true">
      <path
        d="M4 10h12M12 6l4 4-4 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

const StageCard = ({
  cardModifier,
  stageNum,
  stageName,
  dateISO,
  dateFieldLabel,
  pillModifier,
  pillText,
  progressMetaLeft,
  progressMetaRight,
  progressFillClass,
  progressWidthPct,
  footer,
}) => (
  <div className={[classNames.stageCard, classNames[cardModifier]].join(' ')}>
    <p className={classNames.stageEyebrow}>{`STAGE ${stageNum}`}</p>
    <h3 className={classNames.stageName}>{stageName}</h3>
    <div className={classNames.dateRow}>
      <span className={classNames.dateIcon} aria-hidden="true">
        📅
      </span>
      <p className={classNames.dateText}>
        {dateFieldLabel}: <strong>{dateISO ? moment(dateISO).format('MMM D, YYYY') : '—'}</strong>
      </p>
    </div>
    {pillText ? (
      <div className={[classNames.pill, classNames[pillModifier]].join(' ')}>{pillText}</div>
    ) : null}
    {progressFillClass && (
      <>
        <div className={classNames.progressMeta}>
          <span>{progressMetaLeft}</span>
          <span>{progressMetaRight}</span>
        </div>
        <div className={classNames.progressTrack}>
          <div
            className={[classNames.progressFill, classNames[progressFillClass]].join(' ')}
            style={{ width: `${progressWidthPct}%` }}
          />
        </div>
      </>
    )}
    <div className={classNames.cardFooter}>{footer}</div>
  </div>
);

export default StageCard;
